/* ========================================================================== 
   EDME GLOBAL RELATED COLORS PANEL + FOOTER KVKK MODAL
   Product card "+N" renk pop-up sistemi ve e-bülten KVKK pop-up sistemi
   ========================================================================== */

(function() {
  'use strict';

  if (window.__edmeRelatedColorsInit) return;
  window.__edmeRelatedColorsInit = true;

  var activeKvkkModal = null;
  var kvkkLastFocusedElement = null;
  var scrollbarLocked = false;

  function getPanelElements() {
    return {
      overlay: document.querySelector('[data-edme-related-overlay]'),
      panel: document.querySelector('[data-edme-related-panel]'),
      body: document.querySelector('[data-edme-related-body]'),
      closeBtn: document.querySelector('[data-edme-related-close]')
    };
  }

  function escapeHtml(value) {
    if (value == null) return '';

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeAttr(value) {
    if (value == null) return '';

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function decodeHtmlAttribute(value) {
    if (!value) return '';

    var parser = new DOMParser();
    return parser.parseFromString(value, 'text/html').documentElement.textContent;
  }

  function renderRelatedGrid(items) {
    if (!items || !items.length) {
      return '<p style="text-align:center; color:#6B6B6B; padding:40px 0; font-size:12px;">Diğer renk bulunamadı.</p>';
    }

    var html = '<div class="edme-related-grid">';

    items.forEach(function(item) {
      var colorName = item.color || '';
      var imgSrc = item.image || '';
      var title = item.title || '';
      var url = item.url || '#';
      var isCurrent = item.current || item.is_current || false;

      html += '<a href="' + escapeAttr(url) + '" class="edme-related-item' + (isCurrent ? ' is-current' : '') + '">';
      html += '  <div class="edme-related-thumb">';

      if (imgSrc) {
        html += '    <img src="' + escapeAttr(imgSrc) + '" alt="' + escapeAttr(title) + '" loading="lazy">';
      }

      html += '  </div>';

      if (colorName) {
        html += '  <p class="edme-related-name">' + escapeHtml(colorName) + '</p>';
      } else {
        html += '  <p class="edme-related-name edme-related-name--empty">' + escapeHtml(title) + '</p>';
      }

      html += '</a>';
    });

    html += '</div>';

    return html;
  }

  function compensateScrollbar() {
    if (scrollbarLocked) return;

    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';

      var stickyHeader = document.querySelector(
        '.header-wrapper, .section-header, header[role="banner"], .shopify-section-header'
      );

      if (stickyHeader) {
        stickyHeader.style.paddingRight = scrollbarWidth + 'px';
        stickyHeader.setAttribute('data-edme-related-scrollbar-comp', '1');
      }
    }

    document.body.style.overflow = 'hidden';
    scrollbarLocked = true;
  }

  function clearScrollbarCompensation() {
    if (isAnyEdmeModalOpen()) return;

    document.body.style.paddingRight = '';
    document.body.style.overflow = '';

    var compHeader = document.querySelector('[data-edme-related-scrollbar-comp="1"]');

    if (compHeader) {
      compHeader.style.paddingRight = '';
      compHeader.removeAttribute('data-edme-related-scrollbar-comp');
    }

    scrollbarLocked = false;
  }

  function isAnyEdmeModalOpen() {
    var relatedPanel = document.querySelector('[data-edme-related-panel].is-open');
    var kvkkModal = document.querySelector('[data-edme-kvkk-modal].is-visible');

    return Boolean(relatedPanel || kvkkModal);
  }

  function openRelatedPanel(items) {
    var els = getPanelElements();

    if (!els.overlay || !els.panel || !els.body) return;

    els.body.innerHTML = renderRelatedGrid(items);

    compensateScrollbar();

    els.overlay.hidden = false;

    requestAnimationFrame(function() {
      els.overlay.classList.add('is-visible');
      els.panel.classList.add('is-open');
    });

    els.panel.setAttribute('aria-hidden', 'false');
  }

  function closeRelatedPanel() {
    var els = getPanelElements();

    if (!els.overlay || !els.panel || !els.body) return;

    els.panel.classList.remove('is-open');
    els.overlay.classList.remove('is-visible');
    els.panel.setAttribute('aria-hidden', 'true');

    setTimeout(function() {
      els.overlay.hidden = true;
      els.body.innerHTML = '';
      clearScrollbarCompensation();
    }, 380);
  }

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function(element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0;
    });
  }

  function openKvkkModal(trigger) {
    if (!trigger) return;

    var modalId = trigger.getAttribute('aria-controls');
    var modal = modalId ? document.getElementById(modalId) : null;

    if (!modal) return;

    kvkkLastFocusedElement = trigger;
    activeKvkkModal = modal;

    compensateScrollbar();

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(function() {
      modal.classList.add('is-visible');

      var dialog = modal.querySelector('.edme-kvkk-modal__dialog');
      var closeButton = modal.querySelector('[data-edme-kvkk-close]');

      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      } else if (dialog) {
        dialog.focus({ preventScroll: true });
      }
    });
  }

  function closeKvkkModal(modal) {
    var targetModal = modal || activeKvkkModal;

    if (!targetModal) return;

    targetModal.classList.remove('is-visible');
    targetModal.setAttribute('aria-hidden', 'true');

    setTimeout(function() {
      targetModal.hidden = true;

      if (activeKvkkModal === targetModal) {
        activeKvkkModal = null;
      }

      clearScrollbarCompensation();

      if (kvkkLastFocusedElement && document.contains(kvkkLastFocusedElement)) {
        kvkkLastFocusedElement.focus({ preventScroll: true });
      }

      kvkkLastFocusedElement = null;
    }, 320);
  }

  function trapKvkkFocus(event) {
    if (event.key !== 'Tab' || !activeKvkkModal) return;

    var focusable = getFocusableElements(activeKvkkModal);

    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function bindCloseEvents() {
    var els = getPanelElements();

    if (els.closeBtn) {
      els.closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeRelatedPanel();
      });
    }

    if (els.overlay) {
      els.overlay.addEventListener('click', closeRelatedPanel);
    }

    document.addEventListener('keydown', function(e) {
      var currentPanel = document.querySelector('[data-edme-related-panel]');

      if (e.key === 'Escape') {
        if (activeKvkkModal) {
          e.preventDefault();
          closeKvkkModal(activeKvkkModal);
          return;
        }

        if (currentPanel && currentPanel.classList.contains('is-open')) {
          closeRelatedPanel();
        }
      }

      trapKvkkFocus(e);
    });
  }

  function bindTriggerEvents() {
    document.addEventListener('click', function(e) {
      var kvkkOpenTrigger = e.target.closest('[data-edme-kvkk-open]');

      if (kvkkOpenTrigger) {
        e.preventDefault();
        e.stopPropagation();
        openKvkkModal(kvkkOpenTrigger);
        return;
      }

      var kvkkCloseTrigger = e.target.closest('[data-edme-kvkk-close]');

      if (kvkkCloseTrigger) {
        var kvkkModal = kvkkCloseTrigger.closest('[data-edme-kvkk-modal]');

        if (kvkkModal) {
          e.preventDefault();
          e.stopPropagation();
          closeKvkkModal(kvkkModal);
        }

        return;
      }

      var trigger = e.target.closest('[data-related-trigger]');

      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      var raw = trigger.getAttribute('data-related-products');

      if (!raw) return;

      try {
        var decoded = decodeHtmlAttribute(raw);
        var products = JSON.parse(decoded);

        openRelatedPanel(products);
      } catch (err) {
        console.error('[EDME] Related colors parse error:', err);
      }
    });
  }

  function init() {
    bindCloseEvents();
    bindTriggerEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
